import moduleInfo from '../module.json';
import type { AppRuntime } from '@ayocore/platform/client/runtime/AppRuntime';
import { SupplierInvoiceListExtensions } from '@ayocore/erp/procurement/client/components/SupplierInvoices/SupplierInvoiceListExtensions';
import { SupplierInvoiceViewExtensions } from '@ayocore/erp/procurement/client/components/SupplierInvoices/SupplierInvoiceViewExtensions';
import { registerTechnoallianceWelcomeExtensions } from './extensions/TechnoallianceWelcomeExtension';

/**
 * Регистрация клиентской части инстанса technoalliance.
 */
export async function setup(app: AppRuntime): Promise<void> {
  app.useModule(moduleInfo.name, {
    version: moduleInfo.version,
    description: moduleInfo.description,
  });

  // Карточка «Лиды» на главной (велком).
  registerTechnoallianceWelcomeExtensions();

  // Счёт заводится только из карточки закупки: свободный счёт в реестре
  // некому привязать, поэтому кнопку создания там убираем.
  SupplierInvoiceListExtensions.hideStandaloneCreate.register(() => true);

  // В этом процессе счета ведутся по закупкам; блок связей со сделками не используется.
  SupplierInvoiceViewExtensions.hideDealLinks.register(() => true);
}
